import React, { useEffect, useRef, useState } from 'react';
import './InformationLogPage.scss';
import { useDispatch, useSelector, useStore } from 'react-redux';
import { useForm } from 'react-hook-form';
import { useIntl } from 'react-intl';
import {
  getFilterData,
  getJsonFromStorage,
  getPaginationOpts,
  responseLogWithNotification,
  useUpdatePeriod,
} from '../../../utils/utils';
import { getSystemData } from '../../System/reducer';
import { getInformationData } from '../reducer';
import Pagination from '../../../components/base/Pagination/Pagination';
import CustomizedGrid from '../../../components/base/Grid/CustomizedGrid';
import { INFORMATION_LOG_MODULE } from '../../../configs/moduleNames';
import { loadInformationById, loadInformationLogList } from '../actions';
import { informationColumns } from './informationLogColumns';
import FilterRow from '../../../components/base/FilterRow/FilterRow';
import FieldDTO from '../../../components/fields/Abstract/FieldDTO';
import { Icons, Button } from '../../../components/base/BootstrapComponents/BootstrapComponents';
import { POPUP_LIST, POPUP_LIST_NAME } from '../../../configs';
import { addGlobalPopUpWrapper } from '../../InformationScreenWrapper/actions';
import getDefaultSort from '../../../utils/getDefaultSort';
import FilterModal from '../../FilterTemplate/components/FilterModal';
import { PAGE_TYPE } from '../../FilterTemplate/components/filter-settings';
import TimerLoader from '../../../components/base/Loader/TimerLoader';
import TextSearchInput from '../../../components/fields/TextInput/TextSearchInput';
import ExportInterface from '../../System/components/ExportInterface';

export default function InformationLogPage() {
  const blockRef = useRef(null);
  const dispatch = useDispatch();
  const store = useStore();
  const defaultFilterValues = {};
  const { updatePeriod } = useSelector(getSystemData);
  const {
    informationLogList,
    informationLogListMeta,
    loadingInformationLogList,
  } = useSelector(getInformationData);

  const filterName = 'information-filter';
  const [isOpenFilter, setOpenFilter] = useState(false);

  const { formatMessage } = useIntl();
  const loadData = opts => {
    const paginationOpts = getPaginationOpts(store.getState()[INFORMATION_LOG_MODULE].informationLogListMeta, opts);
    const requestData = {
      ...paginationOpts,
      filter: getValues(),
      sort,
    };
    const p1 = dispatch(loadInformationLogList(requestData)).catch(responseLogWithNotification);
    return Promise.all([p1]);
  };
  const [setPeriod] = useUpdatePeriod(loadData, updatePeriod);
  useEffect(() => setPeriod(updatePeriod), [updatePeriod]);

  useEffect(() => reset(getFilterData(filterName, defaultFilterValues)), []);
  const {
    getValues, watch, control, reset, setValue,
  } = useForm({ defaultValues: getJsonFromStorage(filterName, defaultFilterValues) });

  useEffect(() => {
    const subscription = watch(values => {
      localStorage.setItem(filterName, JSON.stringify(values));
      loadData({ page: 1 });
    });
    return () => subscription.unsubscribe();
  }, [watch]);

  const moreFormatter = (_, item) => null;
  const [sort, setSort] = useState(getDefaultSort(informationColumns));

  const changeSort = fieldName => {
    if (sort && (sort === fieldName || sort === `-${fieldName}`)) {
      if (sort === `-${fieldName}`) {
        setSort(fieldName);
      } else if (sort === fieldName) {
        setSort('');
      }
    } else {
      setSort(`-${fieldName}`);
    }
  };

  const rowClassFormatter = item => {
    const classes = ['clickable-table-row'];
    return classes.join(' ');
  };

  useEffect(() => { loadData(); }, [sort]);

  const handleRow = item => {
    dispatch(loadInformationById(item?.id)).then(data => {
      if (data?.inf_type && POPUP_LIST.includes(data?.inf_type)) {
        dispatch((addGlobalPopUpWrapper({ window: item?.inf_type, id: item?.inf_id })));
      }
    });
  };

  return (
    <div className="page information-page">
      <TimerLoader global loading={loadingInformationLogList} />
      <div className="page-title">
        <div className="title-text">{formatMessage({ id: 'menu.information' })}</div>
        <FilterRow>
          <FieldDTO
            control={control}
            component={TextSearchInput}
            dtoObject={{
              name: 'search',
              type: String,
              labelKey: 'search',
            }}
            className="no-border"
          />
          <div className="filter-sep" />
          <ExportInterface page="in_requests" exporter="in_requests" getValues={getValues} />
          <div className="filter-sep" />
          <Button variant="second" onClick={() => setOpenFilter(true)}>
            <Icons customIcon className="file-download" width={24} height={24} icon="filter" />
          </Button>
          {isOpenFilter
            ? (
              <FilterModal
                control={control}
                onClose={() => setOpenFilter(false)}
                getValues={getValues}
                reset={reset}
                defaultValues={defaultFilterValues}
                page={PAGE_TYPE.INFORMATION}
              />
            )
            : null}
        </FilterRow>
      </div>
      <div className="page-content-wrapper">
        <div className="page-content" ref={blockRef}>
          <div className="grid-wrapper frame">
            <div className="custom-scroll-theme sticky-table-wrapper">
              <CustomizedGrid
                data={informationLogList}
                columns={informationColumns}
                name="information-grid"
                settingsFormatter={moreFormatter}
                onDoubleClickByRow={item => {
                  dispatch((addGlobalPopUpWrapper({ window: POPUP_LIST_NAME.INFORMATION_DETAIL, id: item?.id })));
                }}
                changeSort={changeSort}
                rowClassFormatter={rowClassFormatter}
                sort={sort}
              />
            </div>
          </div>
          <Pagination meta={informationLogListMeta} list={informationLogList} handleChangeMeta={loadData} />
        </div>
      </div>
    </div>
  );
}
